import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import styled from "styled-components";
import { RiSnapchatLine } from "react-icons/ri";
import { Flex } from "rebass/styled-components";
import { openWebShare, trackClipSocialShare } from "./utils";

const StyledBackground = styled(Flex)`
  position: relative;
  padding: 8px;
  background: #f7f351;
  border-radius: 50%;
`;

const StyledShare = styled(RiSnapchatLine)`
  position: relative;
  color: #0f100f;
`;

export default function SnapchatShare({ file, clip, ...props }) {
  return (
    <>
      <ShareButton
        justifyContent="center"
        alignItems="center"
        target="_blank"
        onClick={() => {
          try {
            openWebShare({ file, clip });
            trackClipSocialShare({
              platform: "App Share",
              clip,
            });
          } catch (e) {}
        }}
        {...props}
      >
        <Flex alignItems="center">
          <StyledBackground>
            <StyledShare size={16}></StyledShare>
          </StyledBackground>
          <Flex alignItems="flex-start" flexDirection="column"></Flex>
          {props.children}
        </Flex>
      </ShareButton>
    </>
  );
}
